import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";

//пока неиспользуемые
import statusportalsReducer from "./reducers/statusportalsReducer";
import statuswellboresReducer from "./reducers/statuswellboresReducer";

//для порталов
import portalsReducer from "./reducers/portalsReducer";
//для активных скважин
import activewellboresReducer from "./reducers/activewellboresReducer";
//для авторизации
import authReducer from "./reducers/authReducer";
//для инцидентов
import incidentsReducer from "./reducers/incidentsReducer";
//для компов
import compsReducer from "./reducers/compsReducer";
//для пользователей
import usersReducer from "./reducers/usersReducer";
//для общей информации по активных скважин
import generalsReducer from "./reducers/generalsReducer";
//для заказчиков
import customersReducer from "./reducers/customersReducer";
//для пользователей порталов
import portalusersReducer from "./reducers/portalusersReducer";
//для документов
import documentsReducer from "./reducers/documentsReducer";
//для hashtags
import hashtagsReducer from "./reducers/hashtagsReducer";
//для agents
import agentsReducer from "./reducers/agentsReducer";

//для общей фильтрации скважин
import settingsfilter from "./reducers/settingsfilterReducer";

const logger = () => {
  return (next) => (action) => {
    const returnValue = next(action);
    return returnValue;
  };
};

const store = configureStore({
  reducer: {
    portals: portalsReducer,
    statuswellbores: statuswellboresReducer,
    statusportals: statusportalsReducer,
    activewellbores: activewellboresReducer,
    auth: authReducer,
    incidents: incidentsReducer,
    comps: compsReducer,
    users: usersReducer,
    generals: generalsReducer,
    settingsfilter: settingsfilter,
    customers: customersReducer,
    portalusers: portalusersReducer,
    documents: documentsReducer,
    hashtags: hashtagsReducer,
    agents: agentsReducer,
  },
  middleware: [thunk, logger],
});

export default store;
